import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface LearnerContext {
  learnerId: string;
  schoolId: string;
  streamId: string | null;
  classId: string | null;
  firstName: string | null;
  lastName: string | null;
  gradeLevel: string | null;
}

export function useLearnerContext() {
  const [ctx, setCtx] = useState<LearnerContext | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) { if (mounted) { setLoading(false); } return; }
        const { data: l } = await supabase
          .from("learners")
          .select("id, school_id, current_stream_id, first_name, last_name, streams:current_stream_id(class_id, classes:class_id(grade))")
          .eq("user_id", user.id)
          .maybeSingle();
        if (!mounted) return;
        if (!l) { setError("No learner record. Ask your school admin to enroll you."); setLoading(false); return; }
        const stream = (l as { streams: { class_id?: string; classes?: { grade?: string } } | null }).streams;
        setCtx({
          learnerId: l.id,
          schoolId: l.school_id ?? "",
          streamId: l.current_stream_id,
          classId: stream?.class_id ?? null,
          firstName: l.first_name,
          lastName: l.last_name,
          gradeLevel: stream?.classes?.grade ?? null,
        });
        setLoading(false);
      } catch (e) {
        if (mounted) { setError((e as Error).message); setLoading(false); }
      }
    })();
    return () => { mounted = false; };
  }, []);

  return { ctx, loading, error };
}
